<template>
	<c-dialog ref="dialog" title="改价记录" width="700" :resolve="false">
		<div class="price-log-toolbar">
			<c-input name="produce_unique_code" placeholder="背贴码" style="width: 160px;"></c-input>
			<c-button color="main" size="small" prepend-icon="tf-search" @click="search">查询</c-button>
		</div>
		<c-table ref="table" height="400" :paging="{size: 10}" @pagingChange="pageChange">
			<c-table-column type="index" label="序号" width="50"></c-table-column>
			<c-table-column label="商品编码" name="produce_unique_code" width="160"></c-table-column>
			<c-table-column label="IMEI" name="produce_imei" width="150"></c-table-column>
			<c-table-column label="商品信息" name="brand_name" width="160">
				<template #default="{data}">
					{{data.brand_name}} {{data.model_name}} {{data.memory_name}} {{data.color_name}}
				</template>
			</c-table-column>
			<c-table-column label="渠道" name="channel_name" width="100"></c-table-column>
			<c-table-column label="改前价格" name="before_price" width="100">
				<template #default="{data}">¥{{parseFloat(data.before_price || 0).toFixed(2)}}</template>
			</c-table-column>
			<c-table-column label="改后价格" name="after_price" width="100">
				<template #default="{data}">¥{{parseFloat(data.after_price || 0).toFixed(2)}}</template>
			</c-table-column>
			<c-table-column label="调整类型" name="adjust_type" width="80">
				<template #default="{data}">{{adjustTypeText(data.adjust_type)}}</template>
			</c-table-column>
			<c-table-column label="操作人" name="operator_name" width="80"></c-table-column>
			<c-table-column label="改价时间" name="create_date" width="150"></c-table-column>
		</c-table>
	</c-dialog>
</template>

<script>
	export default {
		name: 'salePriceLog',

		data() {
			return {
				productData: {},
				keyword: ''
			}
		},

		methods: {
			open(data) {
				this.productData = data || {};
				this.keyword = this.productData.produce_unique_code || '';
				this.$refs.dialog.open();
				this.$nextTick(() => {
					this.loadData();
				});
			},

			search() {
				var input = this.$el.querySelector('input[name="produce_unique_code"]');
				this.keyword = input ? input.value : '';
				this.$refs.table.clear();
				this.loadData();
			},

			pageChange() {
				this.loadData();
			},

			loadData() {
				this.$refs.table.load({
					url: '/mall/product/priceLog/list',
					data: {
						produce_unique_code: this.keyword
					}
				});
			},

			adjustTypeText(val) {
				return {1: '涨价', 2: '降价', 3: '改价'}[val] || '-';
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.price-log-toolbar {
		display: flex;
		align-items: center;
		gap: 8px;
		margin-bottom: 12px;
	}
</style>
